import styled from '@emotion/styled';
import tokens from '@lacedltd/design-tokens';
import { mediaQuery } from '../../../../helpers/media.js';
import { ContentContainer } from '../CookieBanner.styles.js';
import { generatePadding } from '../../../../helpers/tokens.js';

var _a, _b, _c;
var Container = styled(ContentContainer)((_a = {
        display: "flex",
        flexDirection: "column"
    },
    _a[mediaQuery.m.min] = {
        overflow: "auto",
    },
    _a));
var Content = styled.div((_b = {
        a: {
            textTransform: tokens.textCase.none,
        }
    },
    _b[mediaQuery.m.min] = {
        paddingBottom: tokens.spacing[7],
    },
    _b));
var Footer = styled.footer((_c = {
        backgroundColor: "white"
    },
    _c[mediaQuery.m.max] = {
        position: "sticky",
        bottom: "0",
        padding: generatePadding("spacing.7"),
        boxShadow: "0px 2px 10px 0px rgba(10, 10, 10, 0.19)",
        transform: "translateY(".concat(tokens.spacing[7], ")"),
        marginLeft: "-".concat(tokens.spacing[7]),
        marginRight: "-".concat(tokens.spacing[7]),
    },
    _c[mediaQuery.m.min] = {
        paddingTop: tokens.spacing[5],
        justifyContent: "start",
        boxShadow: "none",
    },
    _c));

export { Container, Content, Footer };
//# sourceMappingURL=ExpandedCookieForm.styles.js.map
